<template>
  <b-container id="bcon"  fluid>
           <img v-if="showloading == true" src="../assets/245.gif" style="z-index: 999;position: fixed; top: 15px;left: 40%;" />
    <b-row>
      <b-col cols="12">

      <table><tr><td>

       <table>
        <tr><td><router-link v-bind:to="'/dashboard'">back</router-link></td><td>hi:&nbsp;{{this.user}}</td><td><a href="#" v-on:click.prevent="logout">log out</a></td></tr>
        <tr><td> <input type="text" v-model="newOrg" placeholder="Enter Organization" >
       </td><td><b-button @click="submitOrg" variant="outline-dark" >Add</b-button> </td>
       </tr></table>

        </td></tr>
        <tr><td>

          <table><tr>
          <td>                  
                <ul id="orgspan" v-for="(docs, index) in this.orgArray" :key="docs.id" >
                   <li id="osspan"
                   :class="{ active : active_el == index }"
                    @click.prevent="getOrg(docs.name);activate(index);" > {{docs.name}} 
                    </li>
            </ul>
            
            </td>
          <td></td>
            <td>

            </td>
          </tr></table>

          </td></tr></table>  
        
      </b-col>      
    </b-row>
    <b-row>
      <b-col  cols="3">
        <table><tr><td>
          <div id="imagediv">
            <div id="buttondiv"> <input type="file"  ref="myFileInput" id="orglogo" accept="image/*" @change="getImage" >
            <div v-if="this.showuploading == true">{{this.uploadValue}}%</div>
            </div>
            <div id="logodiv">

        <img v-bind:src="this.orgData[0].logo" max-width="100%" height="auto" />
        </div>
        </div>
        </td></tr>
        <tr><td>
          <table ><tr><td>Owner: {{this.orgData[0].owner}}</td>
          <td>
            <a @click.prevent="showowner" href="">edit</a>
          
      <table v-if="this.editowner == true"><tr><td><input type="text" id="editowner" v-model="newOwner" ></td><td><b-button variant="outline-dark" @click.prevent="changeowner" href="">invite owner</b-button></td></tr></table>

          
          </td>
          </tr></table>

          
          </td></tr>
          </table>
      </b-col>
           
      <b-col cols="2">
        <table><tr><td>
          <table v-if="this.editorg == false"><tr><td>Organization:&nbsp;{{this.orgData[0].name}}</td><td><a @click.prevent="showorg" href="">edit</a></td></tr></table>

          <table v-if="this.editorg == true"><tr><td>Organization:&nbsp; <input type="text" id="editorg" v-bind:value="this.orgData[0].name" ></td><td><b-button variant="outline-dark" @click.prevent="hideorg()" href="">save</b-button></td></tr></table>

        </td></tr>
        <tr><td>Address<br>
           <div v-if="this.editAddress == false">{{this.orgData[0].orgaddress}}<a @click.prevent="showAddress" href="">edit</a></div>

           <div v-if="this.editAddress == true"><textarea id="editaddy" v-bind:value="this.orgData[0].orgaddres"  ></textarea><b-button variant="outline-dark" @click.prevent="hideAddress()" href="">save</b-button></div>
        </td></tr>
        </table>
        

      </b-col>
      
    </b-row>
    <b-row>
      <b-col cols="5">
         <table><tr><td>

        <table><tr><td> <input type="text" v-model="newAdmin" placeholder="Enter Email" >
       </td><td><b-button @click="sendInvite" variant="outline-dark" >Invite Admin</b-button> </td>
       </tr></table>
    
        </td></tr><tr><td>
          <table><tr><td>
            Admins
            </td></tr><tr><td>
            <div id="admindiv">

              <ul id="" v-for="docs in this.adminslist" :key="docs.id" >
                   <li id=""
                  
                    @click.prevent="getOrg(docs.name);activate(index);" > {{docs.name}} 
                    </li>
                </ul>
            </div>
              </td></tr></table>

          </td></tr></table>

        </b-col>
    </b-row>
  </b-container>
</template>

<script>
import firebase from 'firebase';
//import ElasticEmail from '@elasticemail/elasticemail-client';

export default {
  name: 'organization',
  data (){
    return {
      id: this.$route.params.id,
      //user: "testuser1",
      text: "",
      isTrue1: false,
      showloading: false,
      active_el: null,
      orgArray: [{name:'testOrg1'},{name:'testOrg2'},{name:'testOrg3'}],
      curOrg: "",
      orgData: [],
      newOrg: '',
      newAdmin: '',
      newOwner: '',
      imageData: null,
      uploadValue: 0,
      showuploading: false,
      editorg: false,
      editAddress: false,
      adminslist: null,
      editowner: false
    }
  },
  computed:{
    user(){
      return this.$store.state.user.username;
    },
  },
  methods:{
        showowner: function(){
            this.editowner = true;
          },
        changeowner: function(){
          this.showloading = true;
         
      const user = firebase.auth().currentUser;
    if(this.newOwner != ""){
    firebase.firestore().collection("Users").where("email", "==", this.newOwner).get().then(snap => {
      
      snap.forEach(doc => {
       
        console.log(doc.data().username)

      firebase.firestore().collection("Notifications").add(
      { 
        requester: this.user,
        requestee: doc.data().username,
        requesteeEmail: this.newOwner,
        type: "owner",
        orgid: this.orgData[0].id,
        orgname: this.orgData[0].name,
        requesterEmail: user.email,
        accepted: "no",
        rejected: "no"
      }).then(()=>{
        
        //var message = this.user+" has invited you as admin of Organization "+this.curOrg+" Login to to your account to respond."
       console.log("user: "+this.user+" requesteeEmail: "+this.newOwner+" type"+"owner"+" curOrg: "+this.curOrg+" useremail: "+user.email);
      
      var header = "<h1>Id-Verifier App</h1>";
      var from = "plugvon1@gmail.com";
      var body = "<h1>"+"Id-Verifier App"+"</h1><br /><br /><b>"+this.user+"</b>"+"has invited you to join their organization ["+this.orgData[0].name+ "] as OWNER."+"<br /><br />"+"Login to your account to respond.<a href='https://id-verifier-41bb8.web.app/'>https://id-verifier-41bb8.web.app/</a>";


       

const url = `https://api.elasticemail.com/v2/email/send?apikey=5C34AFA50510E87A91A595552C6D1CD7D4D8BD55FA758434338453F8C49C410182F01A3FE94ADE8682D8449BDA575C5B&subject="id-verifier invite request"&from=${from}&fromName="id-verifier"&to=${this.newOwner}&msgTo=${this.newOwner}&bodyHtml=${body}&headers=${header}&isTransactional=true`;
        
        fetch(url).then(async response => {
      const data = await response.json();

      // check for error response
      if (!response.ok) {
        // get error message from body or default to response statusText
        const error = (data && data.message) || response.statusText;
        return Promise.reject(error);
      }else{
        console.log(data);
        this.newOwner = '';
        this.showloading = false;
        alert("invited sent!");

      }

      
    })
    .catch(error => {
      this.errorMessage = error;
      console.error("There was an error!", error);
    });



      })
    })

      })
    
     }else{
          this.showloading = false;
          alert("Enter Valid Email Address")
        }
    
    },
          submitOrg: function(){
          if(this.newOrg != "" ){
            firebase.firestore().collection("Organizations").add(
              {
                owner: this.user,
                name: this.newOrg,
                address: "",
                logo: ""
              }
            ).then((ref)=>{

                console.log(ref.id)
              firebase.firestore().collection("User.Organizations").add(
              {
                username: this.user,
                orgname: this.newOrg,
                role: "owner",
                orgid: ref.id
              }
            ).then(()=>{
              this.newOrg = "";
            }).catch(error => {
              console.log(error.message)
            })

            }).catch(error => {
              console.log(error.message)
            })

          }

        },
          showAddress: function(){
            this.editAddress = true;
          },
          hideAddress: function(){
            
            var value = document.getElementById("editaddy").value;
            
            console.log(value)
             console.log(this.orgData[0].id)

          if(value != ""){
            this.orgData[0].orgaddress = value;
           firebase.firestore().collection("Organizations").doc(this.orgData[0].id).update({
                address: value
                })
          }
          this.editAddress = false;

          },
          showorg: function(){
            this.editorg = true;
          },
          hideorg: function(){
            
            var value = document.getElementById("editorg").value;
            
            console.log(value)
           

          if(value != ""){
            this.orgData[0].name = value;
           firebase.firestore().collection("Organizations").doc(this.orgData[0].id).update({
                name: value
                })

            firebase.firestore().collection("User.Organizations").where("orgid", "==", this.orgData[0].id).get().then(snap => {
              console.log(snap)
              snap.forEach(doc => {
                console.log(doc)
               firebase.firestore().collection("User.Organizations").doc(doc.id).update({
                orgname: value
                })
            })
            }
            )
          }
          this.editorg = false;

          },
          getImage(event){
            this.showuploading = true;
            this.imageData = event.target.files[0];
            console.log(this.imageData);

                   //this.WData.imageName = this.imageData.name;
      const storageRef=firebase.storage().ref(`${this.imageData.name}`).put(this.imageData);
      
      storageRef.on(`state_changed`,snapshot=>{
        this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
      }, error=>{console.log(error.message)},
      ()=>{this.uploadValue=100;
        storageRef.snapshot.ref.getDownloadURL().then((url)=>{

         this.orgData[0].logo = url;


              firebase.firestore().collection("Organizations").doc(this.orgData[0].id).update({
                logo: url
                })
              //   .then(()=>{
               
              //  })
              
                   this.showuploading = false;
                  this.$refs.myFileInput.value = '';
              
        });
      })
          },
    activate:function(el){
          this.active_el = el;
          if(this.isTrue1 == false){
            this.isTrue1 = true;
          }
          },
        getOrg: function(value){
          this.curOrg = value;
          console.log(this.curOrg);

          this.adminslist = null;

          firebase.firestore().collection("Organizations").where("name", "==", this.curOrg).where("owner", "==", this.user).get().then(snap => {
            let orgs = [];
            snap.forEach(doc => {
              orgs.push({id: doc.id,owner: doc.data().owner,name: doc.data().name,orgaddress: doc.data().address,logo: doc.data().logo})
              this.orgData = orgs;
              console.log("orgData "+this.orgData)
            })
          })

      firebase.firestore().collection("User.Organizations").where("orgname", "==", this.curOrg).where("role", "==", "admin").get().then(snap => {
      let arr = [];
      snap.forEach(doc => {
        //if(doc.exists){
                arr.push({id: doc.id,name: doc.data().username})
                this.adminslist = arr;
                
                console.log("adminlist: ",this.adminslist)
           // }
    })
          })
        },
        logout: function(){
            firebase.auth().signOut();
            this.$store.dispatch('logOut');
            this.$store.dispatch('closeAll');
            this.$router.replace({ name: 'login' });
        },
        sendInvite: function(){
         this.showloading = true;
      const user = firebase.auth().currentUser;
    if(this.newAdmin != ""){
    firebase.firestore().collection("Users").where("email", "==", this.newAdmin).get().then(snap => {
      
      snap.forEach(doc => {
       
        console.log(doc.data().username)

      firebase.firestore().collection("Notifications").add(
      { 
        requester: this.user,
        requestee: doc.data().username,
        requesteeEmail: this.newAdmin,
        type: "admin",
        orgid: this.orgData[0].id,
        orgname: this.orgData[0].name,
        requesterEmail: user.email,
        accepted: "no",
        rejected: "no"
      }).then(()=>{
        
        //var message = this.user+" has invited you as admin of Organization "+this.curOrg+" Login to to your account to respond."
       console.log("user: "+this.user+" requesteeEmail: "+this.newAdmin+" type"+" curOrg: "+this.curOrg+" useremail: "+user.email);
      



     var header = "<h1>Id-Verifier App</h1>";
      var from = "plugvon1@gmail.com";
      var body = "<h1>"+"Id-Verifier App"+"</h1><br /><br /><b>"+this.user+"</b>"+" has invited you to join their organization ["+this.orgData[0].name+ "] as ADMIN."+"<br /><br />"+"Login to your account to respond.<a href='https://id-verifier-41bb8.web.app/'>https://id-verifier-41bb8.web.app/</a>";


       

const url = `https://api.elasticemail.com/v2/email/send?apikey=5C34AFA50510E87A91A595552C6D1CD7D4D8BD55FA758434338453F8C49C410182F01A3FE94ADE8682D8449BDA575C5B&subject="id-verifier invite request"&from=${from}&fromName="id-verifier"&to=${this.newAdmin}&msgTo=${this.newAdmin}&bodyHtml=${body}&headers=${header}&isTransactional=true`;
        
        fetch(url).then(async response => {
      const data = await response.json();

      // check for error response
      if (!response.ok) {
        // get error message from body or default to response statusText
        const error = (data && data.message) || response.statusText;
        return Promise.reject(error);
      }else{
        console.log(data);
        this.newAdmin = '';

        
    firebase.firestore().collection("User.Organizations").where("orgname", "==", this.orgData[0].name).where("role", "==", "admin").get().then(snap => {
      let arr = [];
      snap.forEach(doc => {
        //if(doc.exists){
                arr.push({id: doc.id,name: doc.data().username})
                this.adminslist = arr;
                
                console.log("adminlist: ",this.adminslist)
           // }
    })
          }).then(()=>{
            this.showloading = false;
            alert("invite sent!");
          })
      }

      
    })
    .catch(error => {
      this.errorMessage = error;
      console.error("There was an error!", error);
    });



      })
    })

      })
    
     }else{
          this.showloading = true;
          alert("Enter User Email Address")
        }
    
    }
       
  },
    mounted: function mounted(){

      console.log(this.id)
      console.log(this.editorg)

    firebase.firestore().collection("User.Organizations").where("username", "==", this.user).onSnapshot(snap => {
      let orgs = [];
      snap.forEach(doc => {
        orgs.push({id: doc.id,name: doc.data().orgname})
        this.orgArray = orgs;
        console.log("1")
      })
    })


    firebase.firestore().collection("Organizations").doc(this.id).get().then(doc => {
      let orgs = [];
      //snap.forEach(doc => {
        if(doc.exists){
                orgs.push({id: doc.id,owner: doc.data().owner,name: doc.data().name,orgaddress: doc.data().address,logo: doc.data().logo})
                this.orgData = orgs;
                
                console.log("orgData: ",this.orgData)
            }
            //)
          }).then(()=>{

                  firebase.firestore().collection("User.Organizations").where("orgname", "==", this.orgData[0].name).where("role", "==", "admin").onSnapshot(snap => {
      let arr = [];
      snap.forEach(doc => {
        //if(doc.exists){
                arr.push({id: doc.id,name: doc.data().username})
                this.adminslist = arr;
                
                console.log("adminlist: ",this.adminslist)
           // }
    })
          })

          })
          
            


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

  #app{
    height: 100%;
  }
  html{
    height: 100%;
  }
  body{
    background-color: #f4f4f4;
    width: 100%;
    height: 100%;
  }

  #imagediv{
    width: 250px;
    height: 250px;
   }
  
  #buttondiv{
    width: 100%;
    height: 20%;
    }
  
  #logodiv{
    width: 100%;
    height: 80%;
    background: grey;
    overflow: hidden;
    }


</style>
